// extracted by mini-css-extract-plugin
module.exports = {"chatHeader":"ChatHeader_chatHeader__aUnsy"};